import makeUrl from './makeUrl';
import resolveLinkProps from './resolveLinkProps';

const htmlStringImgUrlConverter = htmlString => {
    const temporaryElement = document.createElement('div');
    temporaryElement.innerHTML = htmlString;
    for (const imgElement of temporaryElement.getElementsByTagName('img')) {
        imgElement.src = makeUrl(imgElement.src, {
            type: 'image-wysiwyg',
            quality: 85
        });
    }
    for (const linkElement of temporaryElement.getElementsByTagName('a')) {
        const linkProps = resolveLinkProps(linkElement.href);
        linkElement.href = linkProps.to || linkProps.href;
    }
    return temporaryElement.innerHTML;
};

export default htmlStringImgUrlConverter;
